import * as React from 'react';

import useWindowSize from '../../shared/hooks/useWindowSize';
import { OpenLockedModal } from '../LockedModal';
import Tabs, { ITab, useTabState } from './Tabs';
import TasksSidebar from './TasksSidebar';
import type { IPathWithItems } from './query';
import { BIG_MOBILE_CUTOFF, SMALL_MOBILE_CUTOFF } from './stylings';
import { DesktopRow, useTwoColStyle } from './useTwoColStyle';
export { IPathWithItems, pathWithItemsFragment } from './query';
export { BIG_MOBILE_CUTOFF, SMALL_MOBILE_CUTOFF } from './stylings';

interface IProps extends React.PropsWithChildren {
    openLockedModal: OpenLockedModal;
    path: IPathWithItems;
    mainLabel: string;
    activeItem?: string;
    startTab?: ITab;
    big: boolean;
}

function WithTasksSidebar({ openLockedModal, path, children, activeItem, startTab, mainLabel, big }: IProps): JSX.Element {
    const { width } = useWindowSize();
    const { showMain, showSidebar, sidebarTab, ...tabsProps } = useTabState(big, startTab);
    const [mainColRef, taskColStyle] = useTwoColStyle(big);
    const cutoff = big ? BIG_MOBILE_CUTOFF : SMALL_MOBILE_CUTOFF;
    if (width < cutoff) {
        return <>
            <Tabs {...tabsProps} mainLabel={mainLabel} big={big} />
            {showMain && <div>
                {children}
            </div>}
            {showSidebar &&
                <TasksSidebar tab={sidebarTab} path={path} openLockedModal={openLockedModal} activeItem={activeItem} />
            }
        </>;
    } else {
        return <>
            <DesktopRow>
                <div style={taskColStyle}>
                    <Tabs {...tabsProps} mainLabel={mainLabel} big={big} />
                    <TasksSidebar tab={sidebarTab} path={path} openLockedModal={openLockedModal} activeItem={activeItem} />
                </div>
                <div ref={mainColRef} style={{ minWidth: 0, position: 'relative', minHeight: '100%' }}>
                    {children}
                </div>
            </DesktopRow>
        </>;
    }
}

export default WithTasksSidebar;
